export const selectOpenIncidents = (state) => {
    return state.stylovyzeIncidents.openIncidents;
};
export const selectActiveIncidents = (state) => state.stylovyzeIncidents.activeIncidents;
